var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMorphology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.43018C0 8.46067 0.572152 9 1.66582 9H10.3291C11.4278 9 12 8.46067 12 7.43018V1.56982C12 0.539326 11.4278 0 10.3291 0H1.66582C0.572152 0 0 0.53451 0 1.56982V7.43018ZM1.76709 1.69984C1.5038 1.69984 1.29114 1.48796 1.29114 1.24719C1.29114 1.01124 1.5038 0.799358 1.76709 0.799358C2.02532 0.799358 2.23797 1.01124 2.23797 1.24719C2.23797 1.48796 2.02532 1.69984 1.76709 1.69984ZM3.26076 1.69984C2.99747 1.69984 2.78987 1.48796 2.78987 1.24719C2.78987 1.01124 2.99747 0.799358 3.26076 0.799358C3.51899 0.799358 3.73165 1.01124 3.73165 1.24719C3.73165 1.48796 3.51899 1.69984 3.26076 1.69984ZM4.75443 1.69984C4.4962 1.69984 4.28354 1.48796 4.28354 1.24719C4.28354 1.01124 4.4962 0.799358 4.75443 0.799358C5.01772 0.799358 5.22532 1.01124 5.22532 1.24719C5.22532 1.48796 5.01772 1.69984 4.75443 1.69984ZM1.00759 7.3435V2.4992H10.9873V7.3435C10.9873 7.81059 10.7291 8.04173 10.2633 8.04173H1.73165C1.26582 8.04173 1.00759 7.81059 1.00759 7.3435Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorphology);
export default __webpack_public_path__ + "static/media/morphology.56b4f4cd879014d450cde0eeb53948e8.svg";
export { ForwardRef as ReactComponent };